export default function Error() {
    return (
      <div className="content">
        <div className="NotFound">
            <p><b>De opgevraagde pagina kan niet geopend worden.</b></p>
            <p>Als gevolg van een technisch probleem is de pagina niet zichtbaar. Wellicht is de informatie die u zoekt elders op de website te vinden.</p>
        </div>
      </div>
    );
  }   